/** Semver from apps/web/package.json - kept in sync by `npm run version:sync` / release scripts. */
export const appVersion = __APP_VERSION__;
